import './item.css';
import 'react-datepicker/dist/react-datepicker.css';

import * as moment from 'moment';
import * as React from 'react';
import { Link } from 'react-router-dom';
import GetMemoAttachment from 'src/apis/GetMemoAttachment';
import Constants from 'src/common/Constants';
import Utility from 'src/common/Utility';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Memo from 'src/entities/Memo';
import MemoComment from 'src/entities/MemoComment';

import CancelWhite from '../../res/img/cancel_white.svg';
import CheckGreen from '../../res/img/check_green.svg';
import DeadlineRed from '../../res/img/deadline_red.svg';
import Download from '../../res/img/download.svg';
import EyeGreen from '../../res/img/eye_green.svg';
import EyeGreenLight from '../../res/img/eye_green_light.svg';
import FistGreen from '../../res/img/fist_green.svg';
import FistGreenLight from '../../res/img/fist_green_light.svg';
import Profile from '../../res/img/member.svg';
import MouthGreen from '../../res/img/mouth_green.svg';
import MouthGreenLight from '../../res/img/mouth_green_light.svg';
import OnlyGreenLight from '../../res/img/only_green_light.svg';
import PenaltyGreenLight from '../../res/img/penalty.svg';
import PencilGreen from '../../res/img/pencil_green.svg';
import PlusRed from '../../res/img/plus_red.svg';
import PlusWhite from '../../res/img/plus_white.svg';
import ReferenceGreenLight from '../../res/img/reference.svg';
// import TrashbinGreenLight from '../../res/img/trashbin_green_light.svg';
import TrashbinWhite from '../../res/img/trashbin_white.svg';
import MemberSelector from './memberSelector';

interface IProps {
  memo: Memo;
  group: Group;
  members: Member[];
  groups: Group[];
  account: Member;
  keywordList?: string[];
  togglePopup: (memoId: number) => void;
  updateMemo: (memo: Memo) => void;
  destroyMemo: (memo: Memo) => void;
}

interface IState {
  isMembersDetailExpanded: boolean;
  isExpanded: boolean;
  comment: MemoComment;
  isEditingMemo: boolean;
  isEditingMemoComment: number;
  isEditingDeadline: boolean;
  isCommentsHouserFloated: boolean;
  memo: Memo;
  isWatcher: boolean;
  isAdmin: boolean;
  tagHeight: number;
  textHeight: number;
  notifiedMembersId: number[];
  reportPattern: 0;
}

class ItemComponent extends React.Component<IProps, IState> {
  editMemo: HTMLTextAreaElement;
  editComment: HTMLTextAreaElement;
  editMemoComment: HTMLTextAreaElement;
  editDeadline: HTMLInputElement;
  commentsHouser: any;

  constructor(props: any) {
    super(props);
    this.state = {
      isMembersDetailExpanded: false,
      isExpanded: false,
      isEditingDeadline: false,
      comment: new MemoComment(),
      isEditingMemo: false,
      isEditingMemoComment: 0,
      memo: JSON.parse(JSON.stringify(this.props.memo)),
      isWatcher: this.props.group.watchers.includes(this.props.account.id),
      isAdmin: this.props.group.admins.includes(this.props.account.id),
      tagHeight: 0,
      textHeight: 0,
      notifiedMembersId: [],
      reportPattern: 0,
      isCommentsHouserFloated: false
    };

    this.expandMembersDetail = this.expandMembersDetail.bind(this);
    this.expand = this.expand.bind(this);
    this.houseComments = this.houseComments.bind(this);
    this.addReporter = this.addReporter.bind(this);
    this.addPerformer = this.addPerformer.bind(this);
    this.addWatcher = this.addWatcher.bind(this);
    this.addMeWatcher = this.addMeWatcher.bind(this);
    this.addComment = this.addComment.bind(this);
    this.onChangeComment = this.onChangeComment.bind(this);
    this.selectStatus = this.selectStatus.bind(this);
    this.onChangeMemo = this.onChangeMemo.bind(this);
    this.onChangeDeadline = this.onChangeDeadline.bind(this);
    this.onEdittngMemo = this.onEdittngMemo.bind(this);
    this.offEditingMemo = this.offEditingMemo.bind(this);
    this.onEditingDeadline = this.onEditingDeadline.bind(this);
    this.offEditingDeadline = this.offEditingDeadline.bind(this);
    this.penaltyMemo = this.penaltyMemo.bind(this);
    this.toggleReportFinal = this.toggleReportFinal.bind(this);
    this.onChangeCommentFile = this.onChangeCommentFile.bind(this);
    this.onChangeGroup = this.onChangeGroup.bind(this);
    this.toggleAllNotification = this.toggleAllNotification.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.onChangeReportPatterns = this.onChangeReportPatterns.bind(this);
  }

  componentDidUpdate() {
    if (this.state.memo.comments.length < this.props.memo.comments.length) {
      this.setState({
        comment: {
          ...this.state.comment,
          text: '',
          binary: ''
        },
        notifiedMembersId: [],
        isExpanded: false
      });
    }

    if (this.state.memo.updated !== this.props.memo.updated) {
      this.setState({
        memo: JSON.parse(JSON.stringify(this.props.memo))
      });
    }
  }

  findMember(memberId: number) {
    const member = this.props.members.find(m => m.id === memberId);
    return member === undefined
      ? {
          id: 0,
          email: '',
          phone: '',
          nameFirst: '',
          nameLast: '',
          password: '',
          profile: null,
          token: '',
          isMailable: false,
          activityChecked: 0,
          archived: false
        }
      : member;
  }

  render() {
    if (!this.state.isAdmin && this.isUnlisted()) {
      return null;
    }

    const creator = this.findMember(this.state.memo.memberId);

    const finalReporter = this.findMember(this.state.memo.finalReporter);

    return (
      <div className="MemoItem">
        <div
          className="Primary"
          ref={houser => {
            this.commentsHouser = houser;
          }}
        >
          <div className="Id">
            <div className="Number">{this.state.memo.id}</div>
            <div className="At">@</div>
            {this.props.account.isSystemAdmin === true ? (
              <select
                className="SelectGroup"
                onChange={this.onChangeGroup}
                defaultValue={String(this.state.memo.groupId)}
              >
                {this.props.groups.map(group =>
                  this.state.memo.groupId === group.id ? (
                    <option selected={true} value={String(group.id)}>
                      {group.title}
                    </option>
                  ) : (
                    <option value={String(group.id)}>{group.title}</option>
                  )
                )}
              </select>
            ) : (
              <div className="Group">{this.props.group.title}</div>
            )}
          </div>
          {!this.state.isEditingMemo ? (
            <div className="Memo" onDoubleClick={this.onEdittngMemo}>
              <div
                className="Tags"
                ref={tag => {
                  if (tag !== null && this.state.tagHeight === 0) {
                    this.setState({
                      tagHeight: tag.clientHeight
                    });
                  }
                }}
              >
                {this.state.memo.tags
                  .filter(tag => this.state.isAdmin || tag !== 'ペナルティ候補')
                  .map(tag => (
                    <div key={tag} className="Tag">
                      #{tag}
                    </div>
                  ))}
              </div>
              <div
                className="Text"
                ref={text => {
                  if (text !== null && this.state.textHeight === 0) {
                    this.setState({
                      textHeight: text.clientHeight
                    });
                  }
                }}
              >
                {this.renderText(this.props.memo.memo)}
              </div>
            </div>
          ) : (
            <div className="Memo">
              <div className="Tags">
                {this.state.memo.tags.map(tag => (
                  <div key={tag} className="Tag">
                    #{tag}
                  </div>
                ))}
              </div>

              <textarea
                ref={memo => {
                  this.editMemo = memo as HTMLTextAreaElement;
                }}
                className="Text"
                onBlur={this.offEditingMemo}
                placeholder="ミーティングメモの内容"
                value={this.state.memo.memo}
                onChange={this.onChangeMemo}
              />
            </div>
          )}
        </div>
        <div className="Secondary">
          <div className="MembersSummary" onClick={this.expandMembersDetail}>
            <div className="MembersSummaryLeft">
              {this.props.memo.reporters.length > 0 ? (
                <div className="Reporters">
                  <div className="TitleImage">
                    <img src={MouthGreenLight} />
                  </div>
                  {this.props.memo.reporters.map(member =>
                    this.renderMemberImage(member)
                  )}
                </div>
              ) : null}

              {this.props.memo.performers.length > 0 ? (
                <div className="Performers">
                  <div className="TitleImage">
                    <img src={FistGreenLight} />
                  </div>
                  {this.props.memo.performers.map(member =>
                    this.renderMemberImage(member)
                  )}
                </div>
              ) : null}

              {this.props.memo.watchers.length > 0 ? (
                <div className="Watchers">
                  <div className="TitleImage">
                    <img src={EyeGreenLight} />
                  </div>
                  {this.props.memo.watchers.map(member =>
                    this.renderMemberImage(member)
                  )}
                </div>
              ) : null}
            </div>
          </div>

          <div
            className={
              this.state.isMembersDetailExpanded
                ? 'MembersDetailExpanded'
                : 'MembersDetail'
            }
          >
            <div className="Reporters">
              <div className="Title">
                <img src={MouthGreen} />
                <span>報告責任者</span>
              </div>
              <div className="Members">
                {this.state.memo.reporters.map(reporter =>
                  this.renderMemberItem(
                    reporter,
                    this.deleteReporter,
                    'reporter'
                  )
                )}
                {this.state.isAdmin &&
                !this.state.memo.completed &&
                this.state.memo.reporters.length === 0 ? (
                  <div className="AddMember">
                    <MemberSelector
                      callback={this.addReporter}
                      members={this.props.members.filter(
                        member =>
                          this.props.group.members.includes(member.id) &&
                          !this.state.memo.reporters.includes(member.id)
                      )}
                    />
                  </div>
                ) : null}
              </div>
            </div>

            <div className="Performers">
              <div className="Title">
                <img src={FistGreen} />
                <span>実行責任者</span>
              </div>
              <div className="Members">
                {this.state.memo.performers.map(performer =>
                  this.renderMemberItem(
                    performer,
                    this.deletePerformer,
                    'performer'
                  )
                )}
                {this.state.isAdmin && !this.state.memo.completed ? (
                  <div className="AddMember">
                    <MemberSelector
                      callback={this.addPerformer}
                      members={this.props.members.filter(
                        member =>
                          this.props.group.members.includes(member.id) &&
                          !this.state.memo.performers.includes(member.id)
                      )}
                    />
                  </div>
                ) : null}
              </div>
            </div>

            <div className="Watchers">
              <div className="Title">
                <img src={EyeGreen} />
                <span>注目</span>
              </div>
              <div className="Members">
                {this.state.memo.watchers.map(watcher =>
                  this.renderMemberItem(watcher, this.deleteWatcher, 'watcher')
                )}

                {!this.state.memo.watchers.includes(this.props.account.id) &&
                !this.state.memo.completed ? (
                  <div className="AddMe" onClick={this.addMeWatcher}>
                    <img
                      src={
                        this.props.account.profile !== null
                          ? this.props.account.profile
                          : Profile
                      }
                    />
                  </div>
                ) : null}

                {this.state.isAdmin && !this.state.memo.completed ? (
                  <div className="AddMember">
                    <MemberSelector
                      callback={this.addWatcher}
                      members={this.props.members.filter(
                        member =>
                          this.props.group.members.includes(member.id) &&
                          !this.state.memo.watchers.includes(member.id)
                      )}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div
            className={
              this.state.isExpanded ? 'Comments' : 'Comments CommentsHoused'
            }
            style={
              this.state.isExpanded
                ? { height: 'auto' }
                : {
                    height:
                      (this.state.tagHeight + this.state.textHeight) * 0.9 +
                      'pt'
                  }
            }
            onClick={this.expand}
          >
            {this.state.isExpanded ? (
              <div>
                {!this.state.isWatcher && !this.state.memo.completed ? (
                  <div className="AddComment">
                    <div className="Member">
                      <img
                        src={
                          this.props.account.profile !== null
                            ? this.props.account.profile
                            : Profile
                        }
                      />
                      <span>{this.props.account.nameLast}</span>
                    </div>
                    <div className="AddCommentDetail">
                      <textarea
                        placeholder="コメントの内容"
                        value={this.state.comment.text}
                        ref={commentRef => {
                          this.editComment = commentRef as HTMLTextAreaElement;
                        }}
                        onChange={this.onChangeComment}
                      />
                      {this.state.comment.binary !== '' ? (
                        <img
                          className="Image"
                          src={this.state.comment.binary}
                        />
                      ) : null}
                      {this.renderNotificationSetting()}
                      <div className="Actions">
                        <div className="Options">
                          <select
                            className="ReportPatterns"
                            onChange={this.onChangeReportPatterns}
                            value={this.state.reportPattern}
                          >
                            <option value={0}>パターン</option>
                            <option value={2}>具体的な指示</option>
                            <option value={3}>抽象的な指示</option>
                            <option value={4}>問題解決</option>
                            <option value={5}>問題提起</option>
                          </select>

                          <label className="File">
                            <span>ファイル</span>
                            <input
                              type="file"
                              onChange={this.onChangeCommentFile}
                            />
                          </label>
                          {this.state.comment.binaryRaw.length > 0 ? (
                            <div className="FileName">
                              {this.state.comment.binaryName}
                            </div>
                          ) : null}

                          {/* <div className="Status" onClick={this.selectStatus}>
                            <input
                              type="checkbox"
                              checked={this.state.comment.callout}
                            />
                            <span>読み上げ</span>
                          </div> */}
                        </div>

                        <button
                          onMouseUp={this.addComment}
                          onTouchEnd={this.addComment}
                        >
                          投稿
                        </button>
                      </div>
                    </div>

                    <div
                      className="CommentsHouser"
                      onClick={this.houseComments}
                    >
                      <div
                        className={
                          this.state.isCommentsHouserFloated
                            ? 'BallFloated'
                            : 'Ball'
                        }
                      >
                        <img src={CancelWhite} />
                        <span>閉じる</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="AddComment">
                    {' '}
                    <div
                      className="CommentsHouser"
                      onClick={this.houseComments}
                    >
                      <div
                        className={
                          this.state.isCommentsHouserFloated
                            ? 'BallFloated'
                            : 'Ball'
                        }
                      >
                        <img src={CancelWhite} />
                        <span>閉じる</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : null}

            {this.state.memo.comments
              .sort((a, b) => (a.created < b.created ? 1 : -1))
              .map(comment => {
                const commentMember = this.findMember(comment.memberId);

                return (
                  <div
                    className="Comment"
                    key={comment.created}
                    onDoubleClick={this.onEditingMemoComment.bind(
                      this,
                      comment.created
                    )}
                  >
                    <div className="CommentMain">
                      <div className="Member">
                        <img
                          src={
                            commentMember.profile !== null
                              ? commentMember.profile
                              : Profile
                          }
                        />
                        <span>{commentMember.nameLast}</span>
                        {/* {this.state.isExpanded ? (
                            <span>{commentMember.nameLast}</span>
                          ) : null} */}
                      </div>

                      {this.state.isEditingMemoComment !== comment.created ? (
                        <div className="Text">
                          {comment.callout ? (
                            <span className="Callout">読み上げ</span>
                          ) : null}

                          <span className="Content">
                            {this.renderText(comment.text)}
                          </span>
                          <span className="Created">
                            {new Date(comment.created).getFullYear() ===
                            new Date().getFullYear()
                              ? Utility.dateFormat(
                                  new Date(comment.created),
                                  'M/d'
                                )
                              : Utility.dateFormat(
                                  new Date(comment.created),
                                  'yy/M/d'
                                )}
                          </span>
                          {comment.notifiedMembersId.length > 0 ? (
                            <div className="NotifiedMembers">
                              {comment.notifiedMembersId.map(memberId =>
                                this.renderMemberImage(memberId)
                              )}
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        <div className="Text">
                          <textarea
                            ref={commentRef => {
                              this.editMemoComment = commentRef as HTMLTextAreaElement;
                            }}
                            onBlur={this.offEditingMemoComment.bind(
                              this,
                              comment.created
                            )}
                            placeholder="コメントの内容"
                            value={comment.text}
                            onChange={this.onChangeMemoComment.bind(
                              this,
                              comment.created
                            )}
                          />
                          {/* <div
                            className="Status"
                            onClick={this.toggleCommentCallout.bind(
                              this,
                              comment.created
                            )}
                          >
                            <input type="checkbox" checked={comment.callout} />
                            <span>読み上げ</span>
                          </div> */}
                        </div>
                      )}
                    </div>
                    <div className="CommentOptional">
                      {comment.binary !== undefined ? (
                        <img className="Preview" src={comment.binary} />
                      ) : null}

                      {comment.hasBinary ? (
                        <div
                          className="DownloadImage"
                          onClick={this.downloadFile.bind(this, comment)}
                        >
                          <img src={Download} />
                          <span>ダウンロード</span>
                        </div>
                      ) : null}

                      {comment.hasBinary ? (
                        <div
                          className="DownloadFile"
                          onClick={this.downloadFile.bind(this, comment)}
                        >
                          <img src={Download} />
                          <span>{comment.binaryName}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}

            {!this.state.isExpanded ? (
              <div className="CommentsExpander">
                <div className="Ball">
                  {this.state.memo.comments.length > 0 ? (
                    this.state.memo.comments.length
                  ) : (
                    <img src={PlusWhite} />
                  )}
                </div>
                <div className="Line" />
              </div>
            ) : null}
          </div>
        </div>

        <div className="Tertiary">
          {this.state.isAdmin ? (
            <div className="Action">
              <img
                className="PenaltyMemo"
                onMouseUp={this.penaltyMemo}
                onTouchEnd={this.penaltyMemo}
                src={PenaltyGreenLight}
              />

              <Link
                to={
                  '/' +
                  this.props.group.title +
                  '/memos/#only=' +
                  this.props.memo.id
                }
                target="_blank"
              >
                <img className="OnlyMemo" src={OnlyGreenLight} />
              </Link>

              <Link
                to={
                  '/' +
                  this.props.group.title +
                  '/memos/reference/' +
                  this.props.memo.id
                }
                target="_blank"
              >
                <img className="ReferMemo" src={ReferenceGreenLight} />
              </Link>

              {/* <img
                className="DeleteMemo"
                onMouseUp={this.destroyMemo.bind(this, this.state.memo)}
                onTouchEnd={this.destroyMemo.bind(this, this.state.memo)}
                src={TrashbinGreenLight}
              /> */}
            </div>
          ) : (
            <div className="Action">
              <Link
                to={
                  '/' +
                  this.props.group.title +
                  '/memos/#only=' +
                  this.props.memo.id
                }
                target="_blank"
              >
                <img className="OnlyMemo" src={OnlyGreenLight} />
              </Link>
            </div>
          )}

          <div
            className={this.state.isExpanded ? 'Others' : 'Others OthersHoused'}
          >
            <div className="Created">
              <div className="Image">
                <img src={PencilGreen} />
                {creator !== undefined ? (
                  <div className="Creator">
                    <div className="Title">作成者</div>
                    <img
                      src={creator.profile !== null ? creator.profile : Profile}
                    />
                    <span>
                      {this.findMember(this.state.memo.memberId).nameLast +
                        this.findMember(this.state.memo.memberId).nameFirst}
                    </span>
                    <div className="Serif" />
                  </div>
                ) : null}
              </div>

              <span>
                {new Date(this.state.memo.created).getFullYear() ===
                new Date().getFullYear()
                  ? Utility.dateFormat(new Date(this.state.memo.created), 'M/d')
                  : Utility.dateFormat(
                      new Date(this.state.memo.created),
                      'yy/M/d'
                    )}
              </span>
            </div>
            <div className="Deadline" onDoubleClick={this.onEditingDeadline}>
              <img src={this.state.memo.completed ? CheckGreen : DeadlineRed} />
              {this.state.isEditingDeadline ? (
                <input
                  type="date"
                  value={Utility.dateFormat(
                    new Date(this.state.memo.deadline),
                    'yyyy-MM-dd'
                  )}
                  onChange={this.onChangeDeadline}
                  onBlur={this.offEditingDeadline}
                  ref={deadline => {
                    this.editDeadline = deadline as HTMLInputElement;
                  }}
                />
              ) : this.state.memo.deadline <= 0 ? (
                <span>---</span>
              ) : this.state.memo.deadline < Date.now() ? (
                <span className="Expired">
                  {Utility.dateFormat(
                    new Date(this.state.memo.deadline),
                    'M/d'
                  )}
                </span>
              ) : (
                <span>
                  {Utility.dateFormat(
                    new Date(this.state.memo.deadline),
                    'M/d'
                  )}
                </span>
              )}
            </div>

            {this.props.memo.reportStatus === Constants.REPORT_FINAL ? (
              <div className="ReportStatus">
                {finalReporter !== undefined ? (
                  <div className="FinalReporter">
                    <div className="Title">変更者</div>
                    <img
                      src={
                        finalReporter.profile !== null
                          ? finalReporter.profile
                          : Profile
                      }
                    />
                    <span>
                      {finalReporter.nameLast}
                      {finalReporter.nameFirst}
                    </span>
                    <div className="Serif" />
                  </div>
                ) : null}

                <span className="Display" onClick={this.toggleReportFinal}>
                  最終報告
                </span>
              </div>
            ) : null}
            {this.state.isAdmin &&
            this.props.memo.reportStatus === Constants.REPORT_INTERIM ? (
              <div className="ReportStatusPossible">
                <span className="Display" onClick={this.toggleReportFinal}>
                  最終報告
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  isUnlisted() {
    return this.state.memo.tags.includes('下書き') ? true : false;
  }

  renderMemberImage(memberId: number) {
    const imageMember = this.findMember(memberId);

    if (imageMember !== undefined) {
      return (
        <div className="MemberImage" key={memberId}>
          <img
            src={imageMember.profile !== null ? imageMember.profile : Profile}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  renderMemberItem(memberId: number, deleteItem: any, type: string) {
    const currentMember = this.findMember(memberId);
    if (this.props.members.map(member => member.id).includes(memberId)) {
      return (
        <div className="MemberItem" key={memberId}>
          <img
            src={
              currentMember.profile !== null ? currentMember.profile : Profile
            }
          />
          <span>
            {this.findMember(memberId).nameLast +
              this.findMember(memberId).nameFirst}
          </span>
          {(this.state.isAdmin || type !== 'watcher') &&
          !this.state.memo.completed ? (
            <div
              className="Trashbin"
              onMouseUp={deleteItem.bind(this, memberId)}
              onTouchEnd={deleteItem.bind(this, memberId)}
            >
              <img src={TrashbinWhite} />
              <div className="Serif" />
            </div>
          ) : null}
        </div>
      );
    } else {
      return null;
    }
  }

  renderText(text: string) {
    const keywordList =
      this.props.keywordList !== undefined ? this.props.keywordList : [];

    const list = [...keywordList, '\n', '[0-9]+番'];
    const regex = new RegExp('(' + list.join('|') + ')', 'g');
    const textArray = text.replace(regex, 'µ$1µ').split('µ');
    return textArray.map((line, lineIndex) => {
      const index = list.indexOf(line);
      if (line.match(/(\n)/g)) {
        return React.createElement('br');
      } else if (line.match(/([0-9]+番)/g)) {
        return React.createElement(
          'span',
          {
            key: lineIndex,
            className: 'Reference',
            onClick: this.showPopup.bind(this, line)
          },
          line
        );
      } else if (index > -1) {
        return React.createElement(
          'span',
          { key: lineIndex, className: 'Searched' },
          list[index]
        );
      } else {
        return line;
      }
    });
  }

  renderNotificationSetting() {
    const members = [
      ...this.props.memo.performers,
      ...this.props.memo.reporters,
      ...this.props.memo.watchers,
      ...this.props.group.admins
    ]
      .filter((memberId, index, self) => self.indexOf(memberId) === index)
      .map(memberId => this.findMember(memberId));

    return (
      <div className="Notifications">
        <div className="Title">通知：</div>

        <div className="AllNotified" onClick={this.toggleAllNotification}>
          全員
        </div>

        {members.map(member =>
          member !== undefined ? (
            <div
              className={
                this.state.notifiedMembersId.includes(member.id)
                  ? 'Notified'
                  : 'UnNotified'
              }
            >
              <img
                src={member.profile !== null ? member.profile : Profile}
                onClick={this.toggleNotification.bind(this, member.id)}
              />
              <div className="Name">
                <span>{member.nameLast}</span>
                <div className="Serif" />
              </div>
            </div>
          ) : null
        )}
      </div>
    );
  }

  toggleNotification(memberId: number) {
    if (this.state.notifiedMembersId.includes(memberId)) {
      this.setState({
        notifiedMembersId: this.state.notifiedMembersId.filter(
          m => m !== memberId
        )
      });
    } else {
      this.setState({
        notifiedMembersId: [...this.state.notifiedMembersId, memberId]
      });
    }
  }

  toggleAllNotification() {
    const members = [
      ...this.props.memo.performers,
      ...this.props.memo.reporters,
      ...this.props.memo.watchers,
      ...this.props.group.admins
    ]
      .filter((memberId, index, self) => self.indexOf(memberId) === index)
      .map(memberId => this.findMember(memberId)) as Member[];

    if (members.length === this.state.notifiedMembersId.length) {
      this.setState({
        notifiedMembersId: []
      });
    } else {
      this.setState({
        notifiedMembersId: members.map(m => m.id)
      });
    }
  }

  showPreview(comment: MemoComment) {
    const api = new GetMemoAttachment();
    api.execute(comment, this.props.account).then(
      (memoComment: MemoComment) => {
        this.setState({
          memo: {
            ...this.state.memo,
            comments: this.state.memo.comments.map(c => {
              if (comment.created === c.created) {
                const blob = new Blob(
                  [Buffer.from(memoComment.binary, 'binary')],
                  {
                    type: memoComment.binaryContentType
                  }
                );

                return {
                  ...c,
                  binary: window.URL.createObjectURL(blob)
                };
              } else {
                return c;
              }
            })
          }
        });
      },
      errorMessage => {
        alert(errorMessage);
      }
    );
  }

  downloadFile(comment: MemoComment) {
    const api = new GetMemoAttachment();
    api.execute(comment, this.props.account).then(
      (memoComment: MemoComment) => {
        const anchor = document.createElement('a') as HTMLAnchorElement;
        anchor.download = comment.binaryName;
        const blob = new Blob([Buffer.from(memoComment.binary, 'binary')], {
          type: memoComment.binaryContentType
        });
        anchor.href = window.URL.createObjectURL(blob);
        document.body.appendChild(anchor);
        anchor.click();
      },
      errorMessage => {
        alert(errorMessage);
      }
    );
  }

  expandMembersDetail() {
    this.setState({
      isMembersDetailExpanded: !this.state.isMembersDetailExpanded
    });
  }

  scrollEventListener = (event: any) => {
    if (this.commentsHouser !== undefined && this.commentsHouser !== null) {
      if (
        this.commentsHouser.getBoundingClientRect().top < -100 &&
        this.commentsHouser.getBoundingClientRect().bottom > 0
      ) {
        this.setState({ isCommentsHouserFloated: true });
      } else {
        this.setState({ isCommentsHouserFloated: false });
      }
    } else {
      this.setState({ isCommentsHouserFloated: false });
    }
  };

  expand() {
    if (this.state.isExpanded === false) {
      this.setState({
        isExpanded: true
      });

      window.addEventListener('scroll', this.scrollEventListener);

      // 画像データを取得
      this.state.memo.comments.forEach(c => {
        if (
          c.binaryContentType !== undefined &&
          c.binaryContentType.includes('image')
        ) {
          this.showPreview(c);
        }
      });

      setTimeout(() => {
        if (this.editComment !== undefined) {
          this.editComment.focus();
        }
      }, 10);
    }
  }

  houseComments() {
    this.setState({
      isExpanded: false
    });
    window.removeEventListener('scroll', this.scrollEventListener);
  }

  addReporter(memberId: number) {
    const memo = Object.assign({}, this.state.memo);
    memo.reporters = [...this.state.memo.reporters, memberId];

    this.setState({
      memo
    });
    this.props.updateMemo(memo);
  }

  addPerformer(memberId: number) {
    const memo = Object.assign({}, this.state.memo);
    memo.performers = [...this.state.memo.performers, memberId];

    this.setState({
      memo
    });
    this.props.updateMemo(Object.assign({}, memo));
  }

  addMeWatcher(e: any) {
    const memo = Object.assign({}, this.state.memo);
    memo.watchers = [...this.state.memo.watchers, this.props.account.id];

    this.setState({
      memo
    });
    this.props.updateMemo(Object.assign({}, memo));
  }

  addWatcher(memberId: number) {
    const memo = Object.assign({}, this.state.memo);
    memo.watchers = [...this.state.memo.watchers, memberId];

    this.setState({
      memo
    });
    this.props.updateMemo(Object.assign({}, memo));
  }

  addComment() {
    if (
      this.state.comment.text.length > 0 &&
      !this.isUselessComment() &&
      !this.isAskingWrong()
    ) {
      const memo = Object.assign({}, this.state.memo);
      memo.comments = [...this.state.memo.comments];
      const comment = Object.assign({}, this.state.comment);
      memo.reportStatus = this.state.memo.reportStatus;
      if (memo.reportStatus === Constants.REPORT_FINAL) {
        memo.finalReporter = this.props.account.id;
      }
      comment.memberId = this.props.account.id;
      comment.created = Date.now();
      comment.notifiedMembersId = this.state.notifiedMembersId;
      memo.comments.push(comment);

      this.props.updateMemo(memo);

      this.setState({
        comment: {
          ...this.state.comment,
          hasBinary: false,
          binaryName: '',
          binaryContentType: '',
          binary: '',
          binaryRaw: ''
        }
      });
    }
  }

  // addComment() {
  //   if (
  //     this.state.comment.text.length > 0 &&
  //     !this.isUselessComment() &&
  //     !this.isAskingWrong()
  //   ) {
  //     const memo = Object.assign({}, this.state.memo);
  //     memo.reportStatus = this.state.memo.reportStatus;
  //     if (memo.reportStatus === Constants.REPORT_FINAL) {
  //       memo.finalReporter = this.props.account.id;
  //     }
  //     this.state.comment.memberId = this.props.account.id;
  //     this.state.comment.created = Date.now();
  //     this.state.comment.notifiedMembersId = this.state.notifiedMembersId;
  //     memo.comments.push(Object.assign({}, this.state.comment));

  //     this.props.updateMemo(memo);
  //     this.setState({
  //       memo,
  //       comment: this.state.comment,
  //       notifiedMembersId: [],
  //       isExpanded: false
  //     });
  //   }
  // }

  isUselessComment(): boolean {
    const text = this.state.comment.text;
    if (
      text.length <= 8 &&
      (text.indexOf('了解') > -1 ||
        text.indexOf('承知') > -1 ||
        text.indexOf('しょうち') > -1 ||
        text.indexOf('りょうかい') > -1 ||
        text.indexOf('わかり') > -1 ||
        text.indexOf('分かり') > -1)
    ) {
      if (
        confirm(
          '有益な情報を含む中間報告を行ってください。\n\n中間報告をする際には、「了解しました」「承知しました」などと記入するだけではなく、指示をふまえて「いつ」「どこで」「だれと」「何をする」など次のアクションについての情報を含めてください（例：○月○日に△△さんと会議を行って、同日中に決定事項を報告します）。\nすぐに対応を決められない場合には、「△△のため、すぐに対応を決められません。○月○日にあらためて状況を報告します」などの形で次のアクションを考えて明示してください。このままで投稿しますか？'
        )
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  isAskingWrong(): boolean {
    const text = this.state.comment.text;
    const isMentioning = text.match(/[＞|>|）](.*)さん/) !== null;
    if (this.state.notifiedMembersId.length === 0 && isMentioning) {
      alert(
        '文中で「＞○○さん」と呼びかけていますが、誰にもメール通知が設定されていません。連絡したい方のアイコンをクリックしてメール通知を有効にしてください。'
      );
      return true;
    } else {
      return false;
    }
  }

  onChangeComment(e: any) {
    this.state.comment.text = e.target.value;
    this.setState({
      comment: this.state.comment
    });
  }

  selectStatus(e: any) {
    const comment = Object.assign({}, this.state.comment);
    comment.callout = !this.state.comment.callout;
    this.setState({
      comment
    });
  }

  selectReportStatus(reportStatus: number) {
    const memo = Object.assign({}, this.state.memo);
    memo.reportStatus = reportStatus;

    this.setState({
      memo
    });
  }

  destroyMemo(memo: Memo, e: any) {
    if (confirm('削除します')) {
      this.props.destroyMemo(memo);
    }
  }

  toggleCommentCallout(created: number, e: any) {
    const memo = Object.assign({}, this.state.memo);
    const memoComment = memo.comments.find(
      comment => comment.created === created
    ) as MemoComment;

    memoComment.callout = !memoComment.callout;

    this.setState({
      memo
    });
  }

  onChangeMemo(e: any) {
    const memo = Object.assign({}, this.state.memo);
    memo.memo = e.target.value;
    memo.tags = Utility.extractTags(e.target.value);

    this.setState({
      memo
    });
  }

  onChangeMemoComment(created: number, e: any) {
    const memo = Object.assign({}, this.state.memo);

    (memo.comments.find(
      comment => comment.created === created
    ) as MemoComment).text = e.target.value;

    this.setState({
      memo
    });
  }

  onChangeDeadline(e: any) {
    if (e.target.value !== '') {
      const memo = Object.assign({}, this.state.memo);
      memo.deadline = 1000 * moment(e.target.value).unix();
      this.setState({
        memo
      });
    }
  }

  onChangeGroup(e: any) {
    alert('このメモの所属するグループを変更しています');
    const memo = Object.assign({}, this.state.memo);
    memo.groupId = Number(e.target.value);
    this.setState({
      memo
    });
    this.props.updateMemo(memo);
  }

  onEdittngMemo(e: any) {
    if (this.state.isAdmin && !this.state.memo.completed) {
      this.setState({
        isEditingMemo: true
      });
      setTimeout(() => {
        this.editMemo.focus();
      }, 10);
    }
  }

  offEditingMemo(e: any) {
    if (this.state.isAdmin) {
      this.setState({
        isEditingMemo: false
      });
    }
    const memo = Object.assign({}, this.state.memo);
    this.props.updateMemo(memo);
  }

  onEditingMemoComment(commentId: number, e: any) {
    const currentComment = this.state.memo.comments.find(
      comment => comment.created === commentId
    ) as MemoComment;

    if (
      (this.state.isAdmin ||
        currentComment.memberId === this.props.account.id) &&
      !this.state.memo.completed
    ) {
      this.setState({
        isEditingMemoComment: commentId
      });
      setTimeout(() => {
        this.editMemoComment.focus();
      }, 10);
    }
  }

  offEditingMemoComment(commentId: number, e: any) {
    const currentComment = this.state.memo.comments.find(
      comment => comment.created === commentId
    ) as MemoComment;

    if (
      this.state.isAdmin ||
      currentComment.memberId === this.props.account.id
    ) {
      setTimeout(() => {
        this.setState({
          isEditingMemoComment: 0
        });

        const memo = Object.assign({}, this.state.memo);
        memo.comments = memo.comments.filter(comment => comment.text.length);

        this.props.updateMemo(memo);
      }, 300);
    }
  }

  onEditingDeadline(e: any) {
    if (this.state.isAdmin && !this.state.memo.completed) {
      this.setState({
        isEditingDeadline: true
      });
      setTimeout(() => {
        this.editDeadline.focus();
      }, 10);
    }
  }

  offEditingDeadline(e: any) {
    if (this.state.isAdmin) {
      this.setState({
        isEditingDeadline: false
      });
      const memo = Object.assign({}, this.state.memo);
      this.props.updateMemo(memo);
    }
  }

  deleteReporter(memberId: number) {
    const memo = Object.assign({}, this.state.memo);
    memo.reporters = this.state.memo.reporters.filter(
      reporter => reporter !== memberId
    );

    this.setState({
      memo
    });
    this.props.updateMemo(memo);
  }

  deletePerformer(memberId: number) {
    const memo = Object.assign({}, this.state.memo);
    if (this.state.memo.performers.length > 1) {
      memo.performers = this.state.memo.performers.filter(
        performer => performer !== memberId
      );

      this.setState({
        memo
      });
      this.props.updateMemo(memo);
    } else {
      alert('実行責任者は１人以上必要です');
    }
  }

  deleteWatcher(memberId: number) {
    const memo = Object.assign({}, this.state.memo);
    memo.watchers = this.state.memo.watchers.filter(
      watcher => watcher !== memberId
    );

    this.setState({
      memo
    });
    this.props.updateMemo(memo);
  }

  toggleReportFinal() {
    if (this.state.isAdmin && !this.state.memo.completed) {
      const memo = Object.assign({}, this.state.memo);
      memo.reportStatus =
        memo.reportStatus === Constants.REPORT_FINAL
          ? Constants.REPORT_INTERIM
          : Constants.REPORT_FINAL;

      if (memo.reportStatus === Constants.REPORT_FINAL) {
        memo.finalReporter = this.props.account.id;
      }

      this.setState({
        memo
      });
      this.props.updateMemo(memo);
    }
  }

  showPopup(reference: string) {
    const memoId = Number(reference.slice(0, -1));
    this.props.togglePopup(memoId);
  }

  penaltyMemo() {
    const memo = Object.assign({}, this.state.memo);
    if (!memo.tags.includes('ペナルティ候補')) {
      memo.tags = [...memo.tags, 'ペナルティ候補'];
    } else {
      memo.tags = memo.tags.filter(tag => tag !== 'ペナルティ候補');
    }
    this.props.updateMemo(memo);
  }

  onChangeCommentFile(e: any) {
    const file = e.target.files[0];

    if (file === undefined) {
      return;
    }

    const filesize = file.size / 1024 / 1024;

    if (filesize > 5) {
      alert('ファイルが5MBを超えているため、アップロードできません。');
      return;
    }

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    // 画像の場合
    if (!file.type.includes('image/')) {
      const comment = Object.assign({}, this.state.comment);
      comment.binary = '';
      this.setState({
        comment
      });
    } else {
      const WIDTH_THRESHOLD = 800;
      const QUALITY_THRESHOLD = 100000;
      const image = new Image();
      image.src = URL.createObjectURL(file);
      image.onload = () => {
        let height = image.naturalWidth;
        let width = image.naturalHeight;
        if (WIDTH_THRESHOLD < image.width) {
          width = WIDTH_THRESHOLD;
          height = image.height * (WIDTH_THRESHOLD / image.width);
        } else {
          width = image.width;
          height = image.height;
        }
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        if (context === null) {
          return;
        }
        context.drawImage(image, 0, 0, width, height);
        let data = '';
        if (QUALITY_THRESHOLD <= file.size) {
          const capacityRatio = QUALITY_THRESHOLD / file.size;
          data = canvas.toDataURL('image/jpeg', capacityRatio);
        } else {
          data = canvas.toDataURL('image/jpeg');
        }

        const comment = Object.assign({}, this.state.comment);
        comment.binary = data;
        this.setState({
          comment
        });
      };
    }

    reader.onload = async () => {
      const result = reader.result as ArrayBuffer;
      const APPLY_MAX = 1024;
      let raw = '';
      for (let i = 0; i < result.byteLength; i += APPLY_MAX) {
        raw += String.fromCharCode.apply(
          null,
          new Uint8Array(result.slice(i, i + APPLY_MAX))
        );
      }

      const comment = Object.assign({}, this.state.comment);
      comment.hasBinary = true;
      comment.binaryName = file.name;
      comment.binaryContentType = file.type;
      comment.binaryRaw = raw;
      this.setState({
        comment
      });
    };

    // const file: Blob = e.target.files[0];

    // const WIDTH_THRESHOLD = 800;
    // const QUALITY_THRESHOLD = 100000;

    // const image = new Image();
    // image.src = URL.createObjectURL(file);
    // image.onload = () => {
    //   let height = image.naturalWidth;
    //   let width = image.naturalHeight;

    //   if (WIDTH_THRESHOLD < image.width) {
    //     width = WIDTH_THRESHOLD;
    //     height = image.height * (WIDTH_THRESHOLD / image.width);
    //   } else {
    //     width = image.width;
    //     height = image.height;
    //   }

    //   const canvas = document.createElement("canvas");
    //   const context = canvas.getContext("2d");
    //   canvas.width = width;
    //   canvas.height = height;

    //   if (context === null) {
    //     return;
    //   }

    //   context.drawImage(image, 0, 0, width, height);

    //   let data = "";
    //   if (QUALITY_THRESHOLD <= file.size) {
    //     const capacityRatio = QUALITY_THRESHOLD / file.size;
    //     data = canvas.toDataURL("image/jpeg", capacityRatio);
    //   } else {
    //     data = canvas.toDataURL("image/jpeg");
    //   }

    //   const comment = Object.assign({}, this.state.comment);
    //   comment.hasBinary = true;
    //   comment.binaryContentType = file.type;
    //   comment.binary = data;
    //   this.setState({
    //     comment,
    //   });
    // };
  }

  onChangeReportPatterns(e: any) {
    const value = Number(e.target.value);
    this.state.comment.text = REPORT_PATTENRS[value] + this.state.comment.text;

    this.setState({
      comment: this.state.comment,
      reportPattern: 0
    });
  }
}

const REPORT_PATTENRS = {
  2: `【指示】[なにをせよ]
【結果】[どうだった]
【目的】[なんのため]
【提案】[どうすべき]
  `,
  3: `【指示】[どうかせよ]
【作業】[なにをした]
【理由】[なぜそうした]
【結果】[どうなった]
`,
  4: `【問題】[まずいこと]
【原因】[なぜおこる]
【対策】[どうしたら]
【結果】[どうなった]
`,
  5: `【経緯】[なにきっかけ]
【問題】[かんどころ]
【考察】[とらえかた]
【提案】[どうすべき]
`
};

export default ItemComponent;



// WEBPACK FOOTER //
// ./src/components/Memo/item.tsx